<script>
  export let exam_session
  export let active_question
  export let i
  export let questions
  export let response
  export let online
  import { syncSessionStores } from '../session-store.js'
  let chosen = response['choice']

  function choose(i, c) {
    if (online) {
      chosen = c
      exam_session.responses[i]['choice'] = c
      exam_session.responses[i]['checked'] = response.checked
      if (c.toUpperCase() === exam_session.responses[i]['correct_answer'].toUpperCase()) {
        exam_session.responses[i]['score'] = 1
      } else {
        exam_session.responses[i]['score'] = 0
      }
      syncSessionStores(exam_session)
      updateSession(exam_session)
    } else {
      alert('Anda sedang offline, jawaban tidak dapat terkirim. Tunggu hingga status menunjukkan "Online".')
    }
  }

  function markQuestion() {
    syncSessionStores(exam_session)
  }

  async function updateSession(exam_session) {
    let url = '/quiz/' + exam_session.id + '/answer'
    await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(exam_session.responses)
    })
  }
</script>

{#if active_question == i}
  <article class="cbt-quiz-question">
    <div class="cbt-quiz-question__head">
      <span class="cbt-quiz-question__badge">Soal {i + 1}</span>
      {#if questions[response.question_uic].bidang_ilmu}
        <span class="cbt-quiz-question__topic">{questions[response.question_uic].bidang_ilmu}</span>
      {/if}
    </div>

    {#if questions[response.question_uic].vignette}
      <div class="cbt-quiz-question__vignette">
        {@html questions[response.question_uic].vignette}
      </div>
    {/if}

    {#if questions[response.question_uic].image}
      <div class="cbt-quiz-question__image">
        <img src="/img/{questions[response.question_uic].image}" alt="Ilustrasi soal">
      </div>
    {/if}

    {#if questions[response.question_uic].question}
      <div class="cbt-quiz-question__text">
        {@html questions[response.question_uic].question}
      </div>
    {/if}

    <div class="cbt-quiz-choices">
      {#each questions[response.question_uic].choices as choice}
        <button
          type="button"
          class="cbt-quiz-choice {chosen == choice.no ? 'cbt-quiz-choice--selected' : ''}"
          on:click={() => choose(i, choice.no)}
        >
          <span class="cbt-quiz-choice__key">{choice.no}</span>
          <span class="cbt-quiz-choice__text">{@html choice.text}</span>
        </button>
      {/each}
    </div>

    <label class="cbt-quiz-mark">
      <input type="checkbox" bind:checked={response.checked} on:change={markQuestion}>
      <span>Tandai soal untuk ditinjau kembali</span>
    </label>
  </article>
{/if}
